import MustHaveChip from './MustHaveChip';

export default MustHaveChip;
